import { feedsConfig as usFeedsConfig } from './feedsConfig';
import sectionsInfo from './sectionsInfo';
import departmentConfig from './departmentConfig';

import { canadaFeedsConfig } from './canadaFeedsConfig';
import canadaSectionsInfo from './canadaSectionsInfo';
import { canadaDepartmentConfig } from './canadaDepartmentConfig';

import { mexicoFeedsConfig } from './mexicoFeedsConfig';
import mexicoSectionsInfo from './mexicoSectionsInfo';
import { mexicoDepartmentConfig } from './mexicoDepartmentConfig';
import { unitedKingdomFeedsConfig } from './unitedKingdomFeedsConfig';
import unitedKingdomSectionsInfo from './unitedKingdomSectionsInfo';
import unitedKingdomDepartmentConfig from './unitedKingdomDepartmentConfig';

export const countryConfigs = {
  us: {
    feedsConfig: usFeedsConfig,
    sectionsInfo: sectionsInfo.us,
    departmentConfig: departmentConfig,
    countryName: 'United States',
    countryCode: 'us',
    flag: '/usFlag.png',
    homePage: '/us',
    getDepartmentConfig: (departmentKey) => {
      const urlToConfigMapping = {
        'departmentofagriculture': 'agriculture',
        'departmentofdefense': 'defense',
        'departmentofcommerce': 'commerce',
        'departmentofjustice': 'justice',
        'departmentofhealth': 'health',
        'departmentofenergy': 'energy',
        'departmentoftransportation': 'transportation',
        'departmentoftreasury': 'treasury',
        'departmentoflabor': 'labor',
        'departmentoftheinterior': 'interior',
        'departmentofhousing': 'housing',
        'departmentofeducation': 'education',
        'departmentofhomeland': 'homeland',
        'departmentofstate': 'state',
        'departmentofveteransaffairs': 'veterans',
        'whitehouse': 'whitehouse'
      };
      const configKey = urlToConfigMapping[departmentKey] || departmentKey;
      return departmentConfig[configKey] || null;
    },
    getDepartmentAgencies: function(departmentKey) {
      const dept = this.getDepartmentConfig(departmentKey);
      return dept ? dept.agencies : [];
    },
    getAgencyConfig: function(departmentKey, agencyId) {
      const agencies = this.getDepartmentAgencies(departmentKey);
      return agencies.find(agency => agency.id === agencyId) || null;
    }
  },
  
  ca: {
    feedsConfig: canadaFeedsConfig,
    sectionsInfo: canadaSectionsInfo.ca,
    departmentConfig: canadaDepartmentConfig,
    countryName: 'Canada',
    countryCode: 'ca',
    flag: '/canadaFlag.png',
    homePage: '/canada', 
    getDepartmentConfig: (departmentKey) => {
      return canadaDepartmentConfig[departmentKey] || null;
    },
    getDepartmentAgencies: function(departmentKey) {
      const dept = this.getDepartmentConfig(departmentKey);
      return dept ? dept.agencies : [];
    },
    getAgencyConfig: function(departmentKey, agencyId) {
      const agencies = this.getDepartmentAgencies(departmentKey);
      return agencies.find(agency => agency.id === agencyId) || null;
    },
    getDepartmentMobileFeeds: (departmentKey) => {
      const dept = canadaDepartmentConfig[departmentKey];
      if (!dept) return [];
      
      const feeds = [];
      dept.mainFeeds.forEach(feed => {
        feeds.push({
          id: feed.id,
          name: feed.name,
          displayType: 'normal',
          apiParams: feed.apiParams,
          feedBranch: feed.feedBranch || 'Executive',
          feedTopic: feed.feedTopic || 'N/A',
          buttonName: feed.buttonName || 'Document',
          departmentPage: true,
          agencyRoute: dept.departmentInfo.route
        });
      });
      
      return feeds;
    }
  },

  mx: {
    feedsConfig: mexicoFeedsConfig,
    sectionsInfo: mexicoSectionsInfo.mx,
    departmentConfig: mexicoDepartmentConfig,
    countryName: 'Mexico',
    countryCode: 'mx',
    flag: '/mexicoFlag.png',
    homePage: '/mx',
    getDepartmentConfig: (departmentKey) => {
      return mexicoDepartmentConfig[departmentKey] || null;
    },
    getDepartmentAgencies: function(departmentKey) {
      const dept = this.getDepartmentConfig(departmentKey);
      return dept ? dept.agencies : [];
    },
    getAgencyConfig: function(departmentKey, agencyId) {
      const agencies = this.getDepartmentAgencies(departmentKey);
      return agencies.find(agency => agency.id === agencyId) || null;
    },
    getDepartmentMobileFeeds: (departmentKey) => {
      const dept = mexicoDepartmentConfig[departmentKey];
      if (!dept) return [];
      
      const feeds = [];
      
      // Add main department feeds with department navigation
      dept.mainFeeds.forEach(feed => {
        feeds.push({
          id: feed.id,
          name: feed.name,
          displayType: 'normal',
          apiParams: feed.apiParams,
          feedBranch: feed.feedBranch || 'Executive',
          feedTopic: feed.feedTopic || 'N/A',
          buttonName: feed.buttonName || 'Document',
          departmentPage: true,
          agencyRoute: dept.departmentInfo.route
        });
      });
      
      return feeds;
    }
  },
  uk: {
    feedsConfig: unitedKingdomFeedsConfig,
    sectionsInfo: unitedKingdomSectionsInfo.uk,
    departmentConfig: unitedKingdomDepartmentConfig,
    countryName: 'United Kingdom',
    countryCode: 'uk',
    flag: '/ukFlag.png',
    homePage: '/uk',
    getDepartmentConfig: (departmentKey) => {
      return unitedKingdomDepartmentConfig[departmentKey] || null;
    },
    getDepartmentAgencies: function(departmentKey) {
      const dept = this.getDepartmentConfig(departmentKey);
      return dept ? dept.agencies : [];
    },
    getAgencyConfig: function(departmentKey, agencyId) {
      const agencies = this.getDepartmentAgencies(departmentKey);
      return agencies.find(agency => agency.id === agencyId) || null;
    },
    getDepartmentMobileFeeds: (departmentKey) => {
      const dept = unitedKingdomDepartmentConfig[departmentKey];
      if (!dept) return [];
      
      const feeds = [];
      
      dept.mainFeeds.forEach(feed => {
        feeds.push({
          id: feed.id,
          name: feed.name,
          displayType: 'normal',
          apiParams: feed.apiParams,
          feedBranch: feed.feedBranch || 'Executive',
          feedTopic: feed.feedTopic || 'N/A',
          buttonName: feed.buttonName || 'Document',
          departmentPage: true,
          agencyRoute: dept.departmentInfo.route
        });
      });
      
      return feeds;
    }
  }
};

// Enhanced helper functions
export const getCountryConfig = (countryCode) => {
  return countryConfigs[countryCode] || null;
};

export const getFeedsConfig = (countryCode) => {
  const config = getCountryConfig(countryCode);
  return config ? config.feedsConfig : null;
};

export const getSectionsInfo = (countryCode) => {
  const config = getCountryConfig(countryCode);
  return config ? config.sectionsInfo : null;
};

export const getDepartmentConfig = (countryCode) => {
  const config = getCountryConfig(countryCode);
  return config ? config.departmentConfig : null;
};

export const getCountryDepartmentConfig = (countryCode, departmentKey) => {
  const config = getCountryConfig(countryCode);
  return config ? config.getDepartmentConfig(departmentKey) : null;
};

export const getCountryDepartmentAgencies = (countryCode, departmentKey) => {
  const config = getCountryConfig(countryCode);
  return config ? config.getDepartmentAgencies(departmentKey) : [];
};

export const getCountryAgencyConfig = (countryCode, departmentKey, agencyId) => {
  const config = getCountryConfig(countryCode);
  return config ? config.getAgencyConfig(departmentKey, agencyId) : null;
};

// Get mobile feeds for departments/agencies
export const getCountryDepartmentMobileFeeds = (countryCode, departmentKey) => {
  const config = getCountryConfig(countryCode);
  if ((countryCode === 'ca' || countryCode === 'mx' || countryCode === 'uk') && config.getDepartmentMobileFeeds) {
    return config.getDepartmentMobileFeeds(departmentKey);
  }
  return [];
};

// Enhanced feed transformer for Canada executive section
export const getMobileFeedsForCanadaExecutive = () => {
  const canadaExecutiveFeeds = canadaFeedsConfig.executive || [];
  
  return canadaExecutiveFeeds
    .filter(feed => feed.showOnHomePage !== false)
    .map(feed => {
      const agencyToDepartmentMapping = {
        'cra': 'canada-revenue-agency',
        'impactAssessment': 'impact-assessment-agency', 
        'foodInspection': 'canadian-food-inspection-agency',
        'atlanticOpportunities': 'atlantic-canada-opportunities-agency',
        'feddevOntario': 'federal-economic-development-southern-ontario',
        'borderServices': 'canada-border-services-agency',
        'transportation': 'canadian-transportation-agency',
        'northernEconomicDevelopment': 'canadian-northern-economic-development-agency',
        'financialConsumer': 'financial-consumer-agency',
        'publicHealth': 'public-health-agency',
        'spaceAgency': 'canadian-space-agency'
      };
      
      const departmentRoute = agencyToDepartmentMapping[feed.id];
      
      return {
        id: feed.id,
        name: feed.title,
        displayType: 'normal',
        apiParams: feed.apiEndpoint,
        feedBranch: feed.branch,
        feedTopic: feed.topic,
        buttonName: feed.buttonName,
        departmentPage: departmentRoute ? true : false,
        agencyRoute: departmentRoute ? `/canada/${departmentRoute}` : null
      };
    });
};

// Mexico executive mobile feeds
export const getMobileFeedsForMexicoExecutive = () => {
  const mexicoExecutiveFeeds = mexicoFeedsConfig.executive || [];
  
  return mexicoExecutiveFeeds
    .filter(feed => feed.showOnHomePage !== false)
    .map(feed => {
      const agencyToDepartmentMapping = {
        'president': 'presidencia',
        'segob': 'secretaria-gobernacion', 
        'sre': 'secretaria-relaciones-exteriores',
        'shcp': 'secretaria-hacienda',
        'sedena': 'secretaria-defensa',
        'semar': 'secretaria-marina',
        'sspc': 'secretaria-seguridad',
        'se': 'secretaria-economia',
        'executiveNews': 'secretaria-agricultura',
        'sct': 'secretaria-comunicaciones',
        'welfare': 'secretaria-bienestar',
        'salud': 'secretaria-salud',
        'stps': 'secretaria-trabajo',
        'semarNat': 'secretaria-medio-ambiente',
        'sfp': 'secretaria-funcion-publica',
        'sectur': 'secretaria-turismo'
      };
      
      const departmentRoute = agencyToDepartmentMapping[feed.id];
      
      return {
        id: feed.id,
        name: feed.title,
        displayType: 'normal',
        apiParams: feed.apiEndpoint,
        feedBranch: feed.branch,
        feedTopic: feed.topic,
        buttonName: feed.buttonName,
        departmentPage: departmentRoute ? true : false,
        agencyRoute: departmentRoute ? `/mexico/${departmentRoute}` : null
      };
    });
};

// UK executive mobile feeds

export const getMobileFeedsForUKExecutive = () => {
  const ukExecutiveFeeds = unitedKingdomFeedsConfig.executive || [];
  
  return ukExecutiveFeeds
    .filter(feed => feed.showOnHomePage !== false)
    .map(feed => {
      // Map feed IDs to their corresponding department routes
      const agencyToDepartmentMapping = {
        'no10': 'prime-ministers-office',
        'treasury': 'hm-treasury', 
        'ago': 'attorney-generals-office',
        'dcms': null, // No department page configured
        'secretary-scotland': null, // No department page configured
        'dsit': 'department-for-science-innovation-and-technology',
        'cabinetOffice': 'cabinet-office',
        'dft': 'department-for-transport',
        'fcdo': 'foreign-commonwealth-development-office',
        'home-office': 'home-office',
        'dfe': 'department-for-education',
        'mod': 'ministry-of-defence',
        'dbt': 'department-for-business-and-trade',
        'leader-house-commons': null, // No department page configured
        'leader-house-lords': null, // No department page configured
        'desnz': 'department-for-energy-security-and-net-zero',
        'defra': 'department-for-environment-food-rural-affairs',
        'dlu-hc': 'department-for-levelling-up-housing-and-communities',
        'dwp': 'department-for-work-and-pensions',
        'dhsc': 'department-of-health-and-social-care',
        'moj': 'ministry-of-justice',
        'nio': null, // No department page configured
        'wales': null // No department page configured
      };
      
      const departmentRoute = agencyToDepartmentMapping[feed.id];
      
      return {
        id: feed.id,
        name: feed.title,
        displayType: 'normal',
        apiParams: feed.apiEndpoint,
        feedBranch: feed.branch,
        feedTopic: feed.topic,
        buttonName: feed.buttonName,
        departmentPage: departmentRoute ? true : false,
        agencyRoute: departmentRoute ? `/uk/${departmentRoute}` : null
      };
    });
};

// Validation functions
export const isValidCountry = (countryCode) => {
  return countryConfigs.hasOwnProperty(countryCode);
};

export const isValidSection = (countryCode, sectionKey) => {
  const sectionsInfo = getSectionsInfo(countryCode);
  return sectionsInfo ? sectionsInfo.hasOwnProperty(sectionKey) : false;
};

export const isValidDepartment = (countryCode, departmentKey) => {
  return getCountryDepartmentConfig(countryCode, departmentKey) !== null;
};

export const isValidAgency = (countryCode, departmentKey, agencyId) => {
  return getCountryAgencyConfig(countryCode, departmentKey, agencyId) !== null;
};

// Get all available countries
export const getAvailableCountries = () => {
  return Object.keys(countryConfigs).map(code => ({
    code,
    name: countryConfigs[code].countryName,
    flag: countryConfigs[code].flag,
    homePage: countryConfigs[code].homePage
  }));
};

// Get sections for a country
export const getCountrySections = (countryCode) => {
  const sectionsInfo = getSectionsInfo(countryCode);
  if (!sectionsInfo) return [];
  
  return Object.keys(sectionsInfo).map(sectionKey => ({
    key: sectionKey,
    title: sectionsInfo[sectionKey].title,
    icon: sectionsInfo[sectionKey].iconComponent,
    description: sectionsInfo[sectionKey].description,
    route: `/${countryCode}/${sectionKey}`
  }));
};

// Get departments for a country
export const getCountryDepartments = (countryCode) => {
  const departmentConfig = getDepartmentConfig(countryCode);
  if (!departmentConfig) return [];
  
  return Object.keys(departmentConfig).map(deptKey => {
    const dept = departmentConfig[deptKey];
    return {
      key: deptKey,
      name: dept.departmentInfo.name,
      image: dept.departmentInfo.image,
      route: dept.departmentInfo.route,
      agencyCount: dept.agencies ? dept.agencies.length : 0
    };
  });
};